class TrainingExamPresenter {
  constructor(
    view,
    findObjectUseCase,
    saveObjectUseCase,
    deleteObjectUseCase,
    upsertObjectUseCase
  ) {
    this.view = view;
    this.findObjectUseCase = findObjectUseCase;
    this.saveObjectUseCase = saveObjectUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
    this.upsertObjectUseCase = upsertObjectUseCase;
    this.limit = 10;
    this.current = 1;
    this.where = {};
    this.documents = [];
    this.progress = false;
    this.object = {};
  }

  componentDidMount() {
    this.getData();
    // this.getActiveLinks();
    this.getExpiredLinks();
  }

  getData() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      count: true,
      limit: this.limit,
      skip,
      where: this.where,
      include: ["categories.questions.answers"],
      sort: { createdAt: -1 },
    };

    this.view.showProgress();
    this.progress = true;
    return this.findObjectUseCase
      .execute("exams", query)
      .then(({ count, objects }) => {
        // this.documents = this.documents.concat(objects);
        this.view.setCount(count);
        this.view.setExam(objects);
        this.view.hideProgress();
        this.progress = false;
      })
      .catch((error) => {
        this.progress = false;
        this.view.hideProgress();
        this.view.showError(error);
      });
  }

  onClickExam(learn) {
    this.view.navigateTo("/training/examedit", learn);
  }

  onSubmitSearch(word) {
    this.where = {
      examName: { $regex: word, $options: "i" },
    };
    this.documents = [];
    this.current = 1;
    this.getData();
  }

  onChangeDate(where) {
    // this.init();
    this.where.createdAt = where.createdAt;
    this.getData();
  }

  onDeleteTrain(learns) {
    const collection = "exams";
    this.view
      .showDialog({
        title: "Delete Data?",
        message: "Are you sure you want to delete?",
      })
      .then(() => {
        // this.view.setTrain([]);
        this.deleteObjectUseCase
          .execute(collection, learns.id)
          .then(() => {
            this.getData();
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        this.view.hideProgress();
        this.view.showError(error);
      });
  }

  getCurrentDateString() {
    const isoString = new Date().toISOString().slice(0, 11);
    const time = new Date().toTimeString().slice(0, 8);
    const milliseconds = ".000Z";
    return `${isoString}${time}${milliseconds}`;
  }

  getExpiredLinks() {
    const query = {
      count: true,

      where: {
        date_exp: { $lte: this.getCurrentDateString() },
      },
      include: ["all"],
      sort: { createdAt: -1 },
    };

    return this.findObjectUseCase
      .execute("exam_links", query)
      .then(({ objects }) => {
        this.view.setState({ expiredLinks: objects });
      })
      .catch((error) => {
        this.view.showError(error);
      });
  }

  getActiveLinks(id) {
    const query = {
      count: true,
      limit: 5,
      where: {
        exam: { id: id },
        date_exp: { $gte: this.getCurrentDateString() },
      },
      include: ["all"],
      sort: { createdAt: -1 },
    };

    return this.findObjectUseCase
      .execute("exam_links", query)
      .then(({ objects }) => {
        console.log("el", objects);
        this.view.setActiveLinks(objects);
      })
      .catch((error) => {
        this.view.showError(error);
      });
  }

  generateLink(selectedId, timeExpiration, countDownTimer) {
    console.log("countDownTimer", countDownTimer);
    const timeInput = parseInt(countDownTimer, 10);
    if (timeInput <= 2) {
      this.view.showError("Countdown timer must be greater than 2 minutes.");
      return;
    }
    const collection = "exam_links";
    const object = {
      exam: { id: selectedId },
      date_exp: timeExpiration,
      // minute set 
      timer: timeInput,
    };

    console.log("Object", object);

    const user = this.view.getCurrentUser();
    const admin = "role:" + "admin";

    object.acl = {
      read: [user.id, admin, "*"],
      write: [user.id, admin],
    };

    if (!this.view.validateTimeExpiration(this.view.state.timeExpiration))
      return;
    this.view.showProgress();
    this.saveObjectUseCase
      .execute(collection, object)
      .then((data) => {
        this.view.setState({ generatedLink: data.id });
        this.view.hideProgress();
        this.getActiveLinks(selectedId);
      })
      .catch((error) => {
        this.view.showError(error);
        this.view.hideProgress();
      });
  }

  onDeleteLink(link) {
    const collection = "exam_links";
    this.view
      .showDialog({
        title: "Delete Data?",
        message: "Are you sure you want to delete?",
      })
      .then(() => {
        // this.view.setTrain([]);
        this.deleteObjectUseCase
          .execute(collection, link.id)
          .then(() => {
            this.getActiveLinks();
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        this.view.hideProgress();
        this.view.showError(error);
      });
  }

  // updateLink(editDate_exp) {
  //   const collection = "exam_links";
  //   const object = editLink;

  //   this.view.showProgress();
  //   if (object.id) {
  //     const change = object;
  //     change.id = this.object.id;
  //     this.upsertObjectUseCase
  //       .execute(collection, change)
  //       .then(() => {
  //         this.view.hideProgress();
  //         this.view.showSuccess("SuccessFully Done");
  //       })
  //       .catch((error) => {
  //         this.view.hideProgress();
  //         this.view.showError(error);
  //       });
  //   }
  // }

  updateLink(editingLink) {
    const collection = "exam_links";

    console.log("el", editingLink);

    if (editingLink.id) {
      const updatedLink = { ...editingLink };
      updatedLink.date_exp = editingLink.date_exp;

      console.log("new date", updatedLink.date_exp);

      if (!this.view.validateTimeExpirationEdit(this.view.state.editingLink))
        return;

      this.upsertObjectUseCase
        .execute(collection, updatedLink)
        .then(() => {
          // this.view.hideProgress();
          this.view.setState({ edit: false });
          this.view.showSuccess("Successfully Updated");
          this.getActiveLinks();
        })
        .catch((error) => {
          this.view.hideProgress();
          this.view.showError(error);
        });
    }
  }

  async clearExpiredLinks() {
    try {
      this.view.setState({ clearProgress: true });
      const expiredLinks = this.view.state.expiredLinks;
      for (const link of expiredLinks) {
        await this.deleteObjectUseCase.execute("exam_links", link.id);
      }
      this.view.setState({ clearProgress: false });
      this.getExpiredLinks();
    } catch (error) {
      this.view.showError(error);
    }
  }
}

export default TrainingExamPresenter;
